import React, { useState } from 'react';

import { TableCell } from '@material-ui/core';
import {
  Add,
  AssignmentInd,
  Delete,
  Edit,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Lock,
  LockOpen,
} from '@material-ui/icons';

import { ActionType } from 'types/enums';
import { TableRow as TableRowType, TableRowAction } from 'types/other';

import { TableRow, IconButton } from './style';

const ACTION_ICON_MAP: { [ActionType: string]: React.ReactNode } = {
  [ActionType.ADD]: <Add />,
  [ActionType.EDIT]: <Edit />,
  [ActionType.DELETE]: <Delete />,
  [ActionType.SWITCH]: <AssignmentInd />,
  [ActionType.BLOCK]: <LockOpen />,
  [ActionType.UNBLOCK]: <Lock />,
  [ActionType.NONE]: <Lock display="none" />, // invisible placeholer icon used to keep alignment
};

export interface TableComponentRowProps {
  data: React.ReactNode[];
  actions?: TableRowAction[];
  onRowClick?: () => void;
  nestedRows?: TableRowType[];
  level?: number;
}

export const TableComponentRow = ({
  data,
  actions = [],
  onRowClick,
  nestedRows = [],
  level = 0,
}: TableComponentRowProps) => {
  const [expanded, setExpanded] = useState(false);

  const handleClickRow = () => {
    if (onRowClick && nestedRows.length === 0) onRowClick();
    else setExpanded(prev => !prev);
  };

  const handleClickExpand = (event: React.MouseEvent) => {
    event.stopPropagation();
    setExpanded(prev => !prev);
  };

  const blocked = actions.some(({ type }) => type === ActionType.UNBLOCK);

  return (
    <>
      <TableRow hover onClick={handleClickRow} level={level} blocked={blocked}>
        {data.map((cell, index) => (
          <TableCell key={`${cell}-${index}`} style={{ whiteSpace: 'nowrap' }}>
            {index === 0 && (
              <IconButton
                size="small"
                color="primary"
                onClick={handleClickExpand}
                visibility={nestedRows.length > 0 ? 'visible' : 'hidden'}
              >
                {expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              </IconButton>
            )}
            {cell}
          </TableCell>
        ))}
        {actions.length > 0 && (
          <TableCell align="center" style={{ whiteSpace: 'nowrap' }} width="1%">
            {actions.map(({ type, onClick, testId }, index) => (
              <IconButton
                key={index}
                onClick={e => {
                  e.stopPropagation();
                  onClick && onClick();
                }}
                data-testid={testId}
                style={{ visibility: type === ActionType.NONE ? 'hidden' : 'visible' }}
              >
                {ACTION_ICON_MAP[type]}
              </IconButton>
            ))}
          </TableCell>
        )}
      </TableRow>
      {expanded &&
        nestedRows.map(({ cells, actions, onClick, children }, index) => (
          <TableComponentRow
            key={index}
            data={cells}
            actions={actions}
            onRowClick={onClick}
            nestedRows={children}
            level={level + 1}
          />
        ))}
    </>
  );
};
